import { createContext, useContext } from 'react';

interface AppLayoutContextValue {
  layoutOffset: number;
}

const AppLayoutContext = createContext<AppLayoutContextValue>({
  layoutOffset: 0,
});

export const AppLayoutProvider = AppLayoutContext.Provider;

export function useAppLayoutOffset() {
  return useContext(AppLayoutContext).layoutOffset;
}
